module.exports = __webpack_public_path__ + "img/img_security_streaming.88c23a4c.svg";